import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl, 
});

axiosInstance.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If the server returns 401 (Unauthorized) or 403 (Forbidden)
    // it means the saved token is no longer valid or recognized.
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('token');
      // Force a reload to the login page to clear the app state
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;